export default "__VITE_ASSET__DTcj0lZ3__"